import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=6404dc4a&scoped=true"
import script from "./compare.vue?vue&type=script&lang=js"
export * from "./compare.vue?vue&type=script&lang=js"
import style0 from "./compare.vue?vue&type=style&index=0&id=6404dc4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6404dc4a",
  null
  
)

export default component.exports